import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'firstName' })
export class FirstNamePipe implements PipeTransform {

    public transform(value: any, args?: any): any {

        if (!value || typeof(value) !== 'string') return null;

        const slices = value.split(' ');

        if (slices.length >= 1) return slices[0];

        return null;
    }

}
